import { useLocalStorage } from '@vueuse/core'

export const usePrintServerUrl = () => {
  return useLocalStorage('printServerUrl', 'https://192.168.0.120:3031')
}
